import axios from 'axios';
import { BASE_URL, ENDPOINTS } from './config';

// Wrapper function for admin login
export const loginAdmin = async (email, password) => {
  try {
    const response = await axios.post(`${BASE_URL}${ENDPOINTS.loginAdmin}`, {
      email,
      password,
    });

    return response.data; // Return response data (token, etc.)
  } catch (error) {
    console.error('Error during admin login:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
};



const makePrivateRequest = {
  async get(url, config) {
    return await this.request("get", url, config);
  },

  async post(url, data, config) {
    return await this.request("post", url, data, config);
  },

  async put(url, data, config) {
    return await this.request("put", url, data, config);
  },

  async patch(url, data, config) {
    return await this.request("patch", url, data, config);
  },

  async delete(url, config) {
    return await this.request("delete", url, config);
  },

  async request(method, url, data = null, config = {}) {
    const token = localStorage.getItem("token");
    try {

      if (token) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        };
      }

      const response = await axios({
        method,
        url,
        data,
        ...config,
      });

      return response.data;
    } catch (error) {
      // Handle errors, e.g., redirect to login page for unauthorized access
      const status = error?.response?.status;

      console.error("Error in making request", status, error?.response?.data?.err, token);
      if (status === 400 && error.response.data.err === 'Invalid token') {
        localStorage.removeItem("token");
        window.location.href = '/login';
      }

      console.error("Error:", error);
      throw error;
    }
  },
};
export const getAllCourses = async () => {
    try {
      const response = await axios.get(`${BASE_URL}${ENDPOINTS.getAllCourse}`);
      return response.data; // Assuming your API returns data in the body
    } catch (error) {
      console.error("Error fetching courses:", error);
      throw error; // Rethrow error for handling in the calling function
    }
  };


  export const getCourseById = async (id) => {
    try {
      const response = await axios.get(`${BASE_URL}${ENDPOINTS.getCourseById}/${id}`);
      return response.data; // Assuming your API returns data in the body
    } catch (error) {
      console.error("Error fetching course by Id:", error);
      throw error; // Rethrow error for handling in the calling function
    }
  };


  export const updateCourseById = async (id, data) => {
    try {
      const response = await axios.patch(`${BASE_URL}${ENDPOINTS.updateCourseById}/${id}`, data);
      return response.data; // Assuming your API returns data in the body
    } catch (error) {
      console.error("Error updating course by Id:", error);
      throw error; // Rethrow error for handling in the calling function
    }
  };


  export const getUnitDetails = async (courseId, unitId) => {
    try {
      const response = await axios.get(`${BASE_URL}${ENDPOINTS.getUnitDetails}/${courseId}/${unitId}`);
      return response.data; // Assuming your API returns data in the body
    } catch (error) {
      console.error("Error updating course by Id:", error);
      throw error; // Rethrow error for handling in the calling function
    }
  };


  export const updateLevelById = async (id, data) => {
    try {
      const response = await axios.put(`${BASE_URL}${ENDPOINTS.updateLevel}/${id}`, {levelData: data});
      return response.data; 
    } catch (error) {
      console.error("Error updating course by Id:", error);
      return error; 
    }
  };

  export const createQuestionForLevel = async (payload, attachments) => {
  try {
    // Construct form data and append payload and files
    const formData = new FormData();
    formData.append("payload", JSON.stringify(payload));

    if (attachments?.questionAudioFile) {
      formData.append("questionAudio", attachments.questionAudioFile);
    }

    if (attachments?.hintAudioFile) {
      formData.append("hintAudio", attachments.hintAudioFile);
    }

    // Append option audio files and collect their metadata
    const optionMeta = [];
    for (const { file, text } of attachments?.optionAudioFiles ?? []) {
      if (file) {               // Skip empty entries early
        optionMeta.push(text ?? "");       // Track accompanying option text
        formData.append("optionAudioFiles", file);
      }
    }
    if (optionMeta.length) {
      formData.append("optionAudioMeta", JSON.stringify(optionMeta));
    }

    const response = await makePrivateRequest.post(
      `${BASE_URL}${ENDPOINTS.createQuestionForLevel}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error creating question for level:", error);
    return {
      success: false,
      error: error?.response?.data || error,
    };
  }
};

export const archiveQuestionsForLevel = async (levelId, questionIds) => {
  try {
    const response = await makePrivateRequest.post(
      `${BASE_URL}${ENDPOINTS.archiveLevelQuestions}`,
      { levelId, questionIds }
    );
    return response;
  } catch (error) {
    console.error("Error archiving questions for level:", error);
    throw error?.response?.data || error;
  }
};

export const restoreQuestionsForLevel = async (levelId, questionIds) => {
  try {
    const response = await makePrivateRequest.post(
      `${BASE_URL}${ENDPOINTS.restoreLevelQuestions}`,
      { levelId, questionIds }
    );
    return response;
  } catch (error) {
    console.error("Error restoring questions for level:", error);
    throw error?.response?.data || error;
  }
};
  
  // export const createQuestionForLevel = async (payload, attachments) => {
  //   // TODO: wire this helper to the question creation endpoint once it is available.
  //   try {
  //     console.log("createQuestionForLevel called with payload:", payload);
  //     if (attachments) {
  //       console.log("createQuestionForLevel received attachments:", attachments);
  //     }

  //     const response = await axios.post(`${BASE_URL}${ENDPOINTS.createQuestionForLevel}`, payload);
  //     return { res: response.data, success: true, error: null };
  //   } catch (error) {
  //     console.error("Error creating question for level:", error);
  //     return { res: null, success: false, error: error };
  //   }
  // };

  // export const uploadQuestionAudioAsset = async (formData) => {
  //   // TODO: replace this placeholder with a multipart request to persist audio assets.
  //   console.log("uploadQuestionAudioAsset called with formData keys:", Array.from(formData?.keys?.() || []));
  //   return { success: false, message: "Audio upload endpoint not implemented yet." };
  // };

  export const getAllUviForAdmin  = async (courseId , courseName) => {
    try {
      const response = await makePrivateRequest.get(`${BASE_URL}${ENDPOINTS.getAllUviForAdmin}?courseId=${courseId}&courseName=${courseName}`);
      return response.data; 
    } catch (error) {
      console.error("Error :", error);
      return error; 
    }
  };

  export const getAIReviewedUVIQuestions  = async (courseId , courseName) => {
    try {
      console.log("courseId", courseId);  
      console.log("courseName", courseName);  
      const response = await makePrivateRequest.get(`${BASE_URL}${ENDPOINTS.getAIReviewedUVIQuestions}?courseId=${courseId}&courseName=${courseName}`);
      return response.data; 
    } catch (error) {
      console.error("Error :", error);
      return error; 
    }
  };

  export const getAllUpgradedLARForAdmin  = async (courseId , courseName) => {
    try {
      const response = await makePrivateRequest.get(`${BASE_URL}${ENDPOINTS.getAllUpgradedLARForAdmin}?courseId=${courseId}&courseName=${courseName}`);
      return response.data; 
    } catch (error) {
      console.error("Error :", error);
      return error; 
    }
  };

  export const reviewQuestion  = async (enrolledQuestionId,  expertAction, expertRemark) => {
    try {
      const response = await makePrivateRequest.post(`${BASE_URL}${ENDPOINTS.reviewQuestion}`, {enrolledQuestionId, expertRemark, expertAction});
      return response; 
    } catch (error) {
      console.error("Error :", error);
      return error; 
    }
  };


  export const uploadExcelForCourse = async(data) => {
    try {
      const response = await makePrivateRequest.post(`${BASE_URL}${ENDPOINTS.uploadExcelForCourse}`, data);
      return response; 
    } catch (error) {
      console.error("Error :", error);
      return error; 
    }
  }


  export const linkAudioForCourse = async(data) => {
    try {
      const response = await makePrivateRequest.post(`${BASE_URL}${ENDPOINTS.linkAudioForCourse}`, data);
      return response; 
    } catch (error) {
      console.error("Error :", error);
      return error; 
    }
  }

  export const updateAudioFileForQuestion = async(data) => {
    try {
      const response = await makePrivateRequest.post(`${BASE_URL}${ENDPOINTS.updateAudioFileForQuestion}`, data, {
        headers: {
          "Content-Type": "multipart/form-data", // Required for file uploads
        }
      });
      return response; 
    } catch (error) {
      console.error("Error :", error);
      return error; 
    }
  }

  export const uploadFlag = async(data) => {
    try {
      const response = await makePrivateRequest.post(`${BASE_URL}${ENDPOINTS.uploadFlag}`, data, {
        headers: {
          "Content-Type": "multipart/form-data", // Required for file uploads
        }
      });
      return response; 
    } catch (error) {
      console.error("Error :", error);
      return error; 
    }
  }

  

export const markCoursePublish = async(data) => {
  try {
    const response = await makePrivateRequest.post(`${BASE_URL}${ENDPOINTS.markCoursePublish}`, data);
    return response; 
  } catch (error) {
    console.error("Error :", error);
    return error; 
  }
}


export const updateCourseStatus = async(data) => {
  try {
    const response = await makePrivateRequest.post(`${BASE_URL}${ENDPOINTS.updateCourseStatus}`, data);
    return response; 
  } catch (error) {
    console.error("Error :", error);
    return error; 
  }
}

export const getUserSubscriptionForAdmin  = async (userId) => {
  try {
    const response = await makePrivateRequest.post(`${BASE_URL}${ENDPOINTS.getUserSubscriptionForAdmin}`, {userId});
    return response; 
  } catch (error) {
    console.error("Error :", error);
    return error; 
  }
};
export const deleteCourse = async(data) => {
  try {
    const response = await makePrivateRequest.post(`${BASE_URL}${ENDPOINTS.deleteCourse}`, data);
    return response; 
  } catch (error) {
    console.error("Error :", error);
    return error; 
  }
}
export const setTargetAccent = async(data) => {
  try {
    const response = await makePrivateRequest.post(`${BASE_URL}${ENDPOINTS.setTargetAccent}`, data);
    return response; 
  } catch (error) {
    console.error("Error :", error);
    return error; 
  }
}

export const getAiModels  = async () => {
  try {
    const response = await makePrivateRequest.get(`${BASE_URL}${ENDPOINTS.getAiModels}`);
    return response; 
  } catch (error) {
    console.error("Error :", error);
    return error; 
  }
};